import { Trans, useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import { getSharedGroupsSummary } from '../helpers'

const SharedGroupsAlert = ({ groups }) => {
  const { t } = useTranslation()
  const { count, visibleNames, hiddenCount } = getSharedGroupsSummary(groups)
  const hiddenText = hiddenCount > 0 ? ` ${t('y {{count}} más...', { count: hiddenCount })}` : ''
  const groupNames = `${visibleNames.join(', ')}${hiddenText}`
  const isSingleGroup = count === 1

  return (
    <Alert type="info" size="m">
      <Trans
        i18nKey={isSingleGroup ? 'viewSharedWithOneGroupMessage' : 'viewSharedWithGroupsMessage'}
        values={{ count, groups: groupNames }}
      >
        Esta vista se compartirá con <strong>{{ count }}</strong> {isSingleGroup ? 'grupo' : 'grupos'}:{' '}
        <strong>{{ groups: groupNames }}</strong>.
      </Trans>
    </Alert>
  )
}

export default SharedGroupsAlert
